// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ig4U","col":"styles_col__2a5qS"};